var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.is_indicator_written_status_loaded==true)?[_c('div',{class:_vm.status=='미작성'?'red7':''},[_vm._v(_vm._s(_vm.status))])]:[_c('b-spinner',{attrs:{"small":"","type":"grow"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }